/**
 * [formatNumber Formats a number to 2 decimal places. For example, 100.2377 -> 100.24]
 * @param  {Number} num
 *
 * @return {Number}
 */
export default function formatNumber(num) {
  let numInput = num;
  let number = Math.abs(num).toFixed(2);
  number = number.toString();
  var afterPoint = "";
  if (number.indexOf(".") > 0)
    afterPoint = number.substring(number.indexOf("."), number.length);
  number = Math.floor(number);
  number = number.toString();
  var lastThree = number.substring(number.length - 3);
  var otherNumbers = number.substring(0, number.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  let res;
  if (numInput < 0) {
    res =
      "-" +
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
  } else {
    res =
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
      lastThree +
      afterPoint;
  }
  return res;
}
